import { Component } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent, InputComponent } from '@core/user-interface-legacy';
import type { ViewsSearchComponent } from '@core/views-types';

@Component({
  selector: 'rt-views-default-search',
  template: `
    <rt-input
      [placeholder]="'app.common.search' | translate"
      [formControl]="searchControl"
      [hasClearButton]="true"
      (reset)="searchControl.setValue(null)"
      class="search"
    >
      <rt-icon prefix name="search" />
    </rt-input>
  `,
  imports: [InputComponent, TranslatePipe, ReactiveFormsModule, IconComponent],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: DefaultSearchComponent.NgInputs,
  styleUrl: './default-search.component.less',
})
export class DefaultSearchComponent implements InstanceType<ViewsSearchComponent> {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  public static readonly NgInputs = ['searchControl' as const];

  public searchControl: FormControl<string | null>;
}

const _TYPE: ViewsSearchComponent = DefaultSearchComponent;
